import dayjs from "dayjs";
import { useSellarCurrentBusiness } from "./useSellarCurrentBusiness.shared";
import { useSellarUser } from "./useSellarUser.shared";
import { useIsSellarAdmin } from "./useIsSellarAdmin";

export const useShowTermsAndConditionsModal = () => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useSellarUser();
  const isAdmin = useIsSellarAdmin();

  if (isAdmin || user?.email.includes("@sellar.io")) return false;

  const termsAccepted = !!business?.TermsAndConditions?.acceptedAt;

  if (termsAccepted) return false;

  const isNewSupplier = dayjs(business?.Supplier?.createdAt).isAfter(
    dayjs("2024-10-29").startOf("day"),
  );

  const enforceTermsAndConditions = dayjs().isAfter(
    dayjs("2024-12-01").startOf("day"),
  );

  return isNewSupplier || enforceTermsAndConditions;
};
